import { FormEvent, PropsWithChildren } from "react"
import classNames from "classnames"

import styles from "./index.module.scss"

interface Props extends PropsWithChildren {
  isChecked?: boolean
  name?: string
  value?: number | string
  label?: string
  id?: string
  errorMessage?: string
  onChange?: (event: FormEvent<HTMLInputElement>) => void
}

export const RadioButton = ({ children, value, name, label, id, errorMessage, onChange, isChecked }: Props) => {
  return (
    <div className={classNames("radioButtonWrapper", styles.fieldWrapper)}>
      {label && <div className={styles.fieldLabelNew}>{label}</div>}
      <label
        htmlFor={id}
        className={classNames("radioLabel", {
          radioLabelChecked: isChecked,
          [styles.error]: errorMessage,
        })}
      >
        <input
          name={name}
          type="radio"
          id={id}
          value={value}
          className={styles.input}
          checked={isChecked}
          onChange={onChange}
        />
        <div className={styles.radioText}>{children}</div>
      </label>
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
    </div>
  )
}
